/**
 * One labelled €/m² source row. Shared by the Price Map detail sidebar and the
 * Lead detail "valuation basis" breakdown so both render the per-source combo
 * identically.
 */

const eur = new Intl.NumberFormat('el-GR', {
  style: 'currency',
  currency: 'EUR',
  maximumFractionDigits: 0,
});

export const fmtEur = (n: number | null | undefined): string =>
  n == null ? '—' : eur.format(n);

export function SourceRow({
  label,
  value,
  count,
  extra,
}: {
  label: string;
  value: number | null;
  count?: number;
  extra?: string | null;
}) {
  return (
    <div className="flex items-baseline justify-between border-b border-slate-100 py-1 last:border-0">
      <div className="text-slate-600">
        {label}
        {count != null && count > 0 && (
          <span className="ml-1 text-slate-400">·n={count}</span>
        )}
      </div>
      <div className={value == null ? 'text-slate-300' : 'font-medium text-slate-900'}>
        {fmtEur(value)}
        {extra && <span className="ml-1 text-[10px] text-slate-400">{extra}</span>}
      </div>
    </div>
  );
}
